<template>
  <div class="app-container">
    <wt-form-table :form.sync="form" @on-button-action="onButtonAction">
      <wt-form-table-list ref="dailyCompanyTableRef" slot="wtFormTableList" :form.sync="form" @on-button-action="onButtonAction"></wt-form-table-list>
    </wt-form-table>
  </div>
</template>

<script>

export default {
  data() {
    return {
      imgUrl: window.wtConst.FILE_SERVER_URL,
      form: { //  表单数据
        isFormLoading: false,
        formCode: 'MODULE_DAILY_COMPANY_LIST',
        formComponent: {
          list: { type: 'default', value: '/modules/integralRules/pointsRecordList' }
        },
        formInputsData: [
          { name: '统计时间',
            key: 'isPublish',
            value: '1',
            type: 'select',
            data: [
              { label: '天', value: '1' },
              { label: '周', value: '2' },
              { label: '月', value: '3' },
              { label: '年', value: '4' }
            ] },
          { name: '日期范围', key: 'updateTimeRange', value: '', type: 'date' }],
        formButtonsData: [{ name: '导出Excel',
          key: 'EXPORT',
          action: 'EXCEL',
          hidden: false,
          url: window.wtConst.BASE_API + '/modules/userIntegralDetails/userIntegralListImport',
          fileName: '子公司日常数据',
          permission: 'EXPORT' }],
        formTableData: [
          { name: '公司名称', key: 'name', type: 'text' },
          { name: '投递重量', key: 'name', type: 'text' },
          { name: '清运台数', key: 'coverPath', type: 'text' },
          { name: '投递次数', key: 'coverPath', type: 'text' },
          { name: '新增用户', key: 'coverPath', type: 'text' },
          { name: '清运总重', key: 'coverPath', type: 'text' },
          { name: '在线台数', key: 'coverPath', type: 'text' },
          { name: '离线台数', key: 'coverPath', type: 'text' },
          { name: '违投次数', key: 'coverPath', type: 'text' },
          { name: '违投金额', key: 'coverPath', type: 'text' },
          { name: '违投重量', key: 'coverPath', type: 'text' },
          { name: '清运人数', key: 'coverPath', type: 'text' },
          { name: '投递金额(元)', key: 'coverPath', type: 'text' },
          { name: '清运金额(元)', key: 'coverPath', type: 'text' },
          { name: '分润金额(元)', key: 'coverPath', type: 'text' }],
        formTableButtonsData: [],
        formResult: {},
        pageData: { currentPage: 0, pageSize: 20, sortName: '', sortOrder: '' },
        formTableProp: { selection: false, buttonHidden: true, index: false }
      }
    }
  },
  methods: {
    /*  ------------------------- 按钮相关  -------------------------  */
    onButtonAction(data) {
      if (data && data.item) {
        // if (data.item.action === 'VIEW' || data.item.action === 'EDIT') {
        // this.$store.dispatch('setLopperDetailData', data.row)
        // }
      }
    }
  }
}
</script>
